import { Link } from "react-router-dom";
import "./NotFound.css";

/* Catch-all for the router. Without this, any URL that matched no route
   rendered an empty <Routes> and the app showed a white screen with no way
   back: a mistyped path looked identical to a crash. */
export default function NotFound() {
  return (
    <div className="notfound-page">
      <p className="notfound-page-code">404</p>
      <h1 className="notfound-page-title">This page does not exist</h1>
      <p className="notfound-page-text">
        The link may be out of date, or the address may have a typo in it.
      </p>
      <Link className="notfound-page-link" to="/home">
        Back to search
      </Link>
    </div>
  );
}
